import React from "react";
import AMRPostReviewList from "./AMRPostReviewList";

const hasInterventionLink = (record) => Boolean(record?.interventionId || record?.intervention);

const AMRPostReviewView = ({
  reviewedMedicationCards,
  medications,
  expandedDiscontinued,
  toggleDiscontinuedExpansion,
  selectMedication,
  getDrugFromCard,
  AdherenceTypes,
}) => {
  return (
    <ul className="divide-y text-sm font-normal divide-gray-100 border-b border-b-gray-100 overflow-y-auto max-h-[32rem]">
      {/* Taking as Prescribed */}
      <li className="">
        <div className={`py-1 px-3 flex items-center justify-between h-[36px] text-gray-800 bg-teal-75`}>
          <span>Taking as Prescribed</span>
        </div>
      </li>
      <AMRPostReviewList
        medications={reviewedMedicationCards?.filter(
          (x) => x.consumption === AdherenceTypes.AsPrescribed
        )}
        selectMedication={selectMedication}
        getDrugFromCard={getDrugFromCard}
      />

      {/* Not Taking as Prescribed */}
      <li className="pt-3">
        <div className={`py-1 px-3 flex items-center justify-between h-[36px] text-gray-800 bg-teal-75`}>
          <span>Not Taking as Prescribed</span>
        </div>
      </li>
      <AMRPostReviewList
        medications={reviewedMedicationCards?.filter(
          (x) => x.consumption === AdherenceTypes.NotAsPrescribed
        )}
        selectMedication={selectMedication}
        getDrugFromCard={getDrugFromCard}
      />

      {/* Stopped Taking */}
      <li className="pt-3">
        <div className={`py-1 px-3 flex items-center justify-between h-[36px] text-gray-800 bg-teal-75`}>
          <span>Stopped Taking</span>
        </div>
      </li>
      <AMRPostReviewList
        medications={reviewedMedicationCards?.filter(
          (x) => x.consumption === AdherenceTypes.Stopped
        )}
        selectMedication={selectMedication}
        getDrugFromCard={getDrugFromCard}
      />

      {/* Intervention(s) In Review */}
      <li className="pt-3">
        <div className={`py-1 px-3 flex items-center justify-between h-[36px] text-gray-800 bg-teal-75`}>
          <span>Intervention(s) In Review</span>
        </div>
      </li>
      <AMRPostReviewList
        medications={reviewedMedicationCards?.filter(
          (x) => hasInterventionLink(x)
        )}
        selectMedication={selectMedication}
        getDrugFromCard={getDrugFromCard}
        showInterventionIcon={true}
      />

      {/* Discontinued Medications */}
      <li className="pt-3">
        <div className={`py-1 px-3 flex items-center justify-between h-[36px] text-gray-800 bg-yellow-100`}>
          <span>Discontinued Medications</span>
        </div>
      </li>
      <AMRPostReviewList
        medications={medications?.filter((x) => x.status === "inactive" && x.discontinuedDuringReview === true)}
        selectMedication={selectMedication}
        getDrugFromCard={getDrugFromCard}
        isDiscontinued={true}
        expandedDiscontinued={expandedDiscontinued}
        toggleDiscontinuedExpansion={toggleDiscontinuedExpansion}
      />
    </ul>
  );
};

export default AMRPostReviewView;
